<template>
    <div class="body" :style="'height:'+innerHeight+'px'">
        <van-search
                v-model="searchInput"
                shape="round"
                placeholder="请输入分类"
                @input="onSearch"
        />
        <div class="index-bar" v-if="searchInput">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onload"
            >
                <van-cell v-for="(ite,index) in search_list" :key="index"  >
                        <span v-if="ite.course_id > 0" @click="bindGoCourse(ite.course_id)">
                    {{ ite.name }}
                </span>
                    <span v-else style="color: #aaa;">{{ ite.name }}</span>
                </van-cell>
            </van-list>
        </div>
        <div class="index-bar" v-else >
            <div class="van-index-bar" id="indexBar" v-if="list.length>0">
                <div  v-for="(item,index) in list[right_index].children" :key="index">
                    <div class="van-index-anchor" :id="'k'+index">
                        <div class="index-bg" >
                            <div class="index-name">{{item.name}}</div>
                            <img class="index-img" :src="item.background_img" alt="">
                        </div>
                    </div>

                    <div class="index-list">
                        <span  v-for="(ite,index) in item.children" :key="index" class="index-list-li">
                            <span v-if="ite.course_id > 0" @click="bindGoCourse(ite.course_id)">
                                {{ ite.name }}
                            </span>
                            <span v-else style="color: #aaa;">{{ ite.name }}</span>
                        </span>

                    </div>
                </div>

            </div>

            <div class="van-index-bar"  v-if="list.length>0">
                    <div class="van-index-bar__sidebar">
                        <div class="van-index-bar__sidebar_content" :class="{'show_tab':is_show_tab}">
                            <div v-for="(item,index) in list[right_index].children" :key="index">
                                <span :class="'van-index-bar__index '+(index == bar_index?'curr':'')" @click="bindIndexBar(index)">{{ setString(item.name,8) }}</span>
                            </div>
                            <!--<span :class="'van-index-bar__index '+(index == 2?'curr':'')" @click="bindIndexBar(2)">财务/行政</span>-->
                            <!--<span :class="'van-index-bar__index '+(index == 3?'curr':'')" @click="bindIndexBar(3)">金融</span>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {NavBar,IndexBar, IndexAnchor,Cell,Search,List,PullRefresh } from 'vant';
    export default {
        name: "index",
        components:{
            [Search.name]:Search,
            [List.name]:List,
            [PullRefresh .name]:PullRefresh,
            [NavBar.name]:NavBar,
            [IndexBar.name]:IndexBar,
            [IndexAnchor.name]:IndexAnchor,
            [Cell.name]:Cell
        },
        data(){
            return {
                searchInput:'',
                loading: false,
                finished: false,
                refreshing: false,
                search_list:[],
                total:0,
                page:1,
                pageSize:20,

                bar_index:'',
                innerHeight:0,
                knowledge_map_id:'',
                list:[],
                right_index:0,
                is_show_tab:false,
            }
        },
        mounted() {
            this.innerHeight = window.innerHeight;
            
            this.knowledge_map_id = this.util.getQueryStr('knowledge_map_id');
            if(!this.knowledge_map_id){
                this.knowledge_map_id = this.$route.params&&this.$route.params.knowledge_map_id?this.$route.params.knowledge_map_id:''
            }
            
            console.warn("this.$route.params.knowledge_map_id", this.knowledge_map_id)
            if(this.$route.meta && this.$route.meta.showTab){
              this.is_show_tab = true
            }
            this.init();
        },
        methods:{
            onClickLeft(){
                this.$router.go(-1);
            },
            init:function () {
                var _self=this;
                this.util.server.mini_knowledge_map.get_map_list({
                    methods:'get',
                    callback: (res => {
                        //console.log(res)
                        _self.list = res.data;
                        _self.right_list_refresh(_self.knowledge_map_id)
                    })
                });
            },
            right_list_refresh:function(knowledge_map_id){
                this.knowledge_map_id = knowledge_map_id;
                for(let i=0;i<this.list.length;i++){
                    if(this.list[i].knowledge_map_id == knowledge_map_id){
                        this.right_index = i;
                    }
                }

            },
            bindGoCourse(course_id){
                this.$router.push(this.util.urlPrefix+'/curriculum/index?course_id='+course_id+'&token='+this.util.token)
            },
            bindIndexBar(id){
                this.bar_index = id;
                var offsetTop = document.querySelector('#k'+id+'').offsetTop;
                document.querySelector('.index-bar').scrollTop=offsetTop-54;//54是搜索框的高度
            },
            onSearch(val) {
                if(!!val){
                    this.page=1;
                    this.search_list=[];
                    this.onload(1)
                    this.loading= false;
                    this.finished= false;
                }
            },
            onload(page){
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page=pageNo;

                }else{
                    this.page=page;

                }
                this.util.server.mini_knowledge_map.search_map_list({
                    data:{
                        search:this.searchInput,
                        page:this.page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;

                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.total=data.total
                            }

                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                // for (var i = 0; i < data.items.length; i++) {
                                //     data.items[i]['link'] = this.util.getMiniCourseTypeUrl(data.items[i].type, data.items[i].course_id, data.items[i].p_course_id) + '&current=' + (data.items[i].sections_id || '');
                                // }

                                if(page == 1){
                                    this.search_list=data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.search_list = this.search_list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.loading = false;
                                //判断是否存在下一页
                                if(this.total*1 == this.search_list.length){
                                    this.finished=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.search_list=[];
                                    this.finished=true;
                                    this.loading = false;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });

            },
            setString(str, len) {  //截取字符串,中文字符作两个计算
                var strlen = 0;
                var s = "";
                for (var i = 0; i < str.length; i++) {
                    if (str.charCodeAt(i) > 128) {
                        strlen += 2;
                    } else {
                        strlen++;
                    }
                    s += str.charAt(i);
                    if (strlen >= len) {
                        return s;
                    }
                }
                return s;
            }

        },
        beforeCreate () {
            document.querySelector('body').setAttribute('style', 'background-color:#fff')
        },
        //离开页面事件
        beforeRouteLeave(to, form, next) {
            document.querySelector('body').setAttribute('style', 'background-color:#f8f8f8')
            next();
        },
    }
</script>

<style scoped>

    ::-webkit-scrollbar {
        width: 0;
        height: 0;
        color: transparent;
    }
    .index-bar::-webkit-scrollbar {
        display: none;
    }
    div{
        color: #3a3a3a;
    }
    .body{
        height: 603px;
        display: flex;
        flex-direction: column;
        flex: 1;
    }
    .van-index-anchor{
        z-index: 1;
        box-sizing: border-box;
        padding: 0 1rem;
        color: #323233;
        font-weight: 500;
        font-size: 0.875rem;
        /* line-height: 2rem; */
        background-color: transparent;
    }
    .van-index-bar__sidebar{
        position: fixed;
        top: 50%;
        right: 0;
        z-index: 2;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        flex-direction: column;
        text-align: center;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        cursor: pointer;
        -webkit-user-select: none;
        user-select: none;

        overflow:hidden;
        margin-right:5px;
        max-height: 100%;
    }
    .van-index-bar__sidebar_content{
        display: inline-block;
        height: 100%;
        overflow: hidden;
        overflow-y: scroll;
        padding: 10px 5px;
        background-color:#fff;
        border:1px solid #ebedf0;
        border-radius:23px;
        width:30px;
        margin-top: 54px;
    }
    .show_tab{
        margin-bottom: 75px;
    }
    .van-index-bar__sidebar span{
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: clip;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .van-index-bar__sidebar  .van-index-bar__index{
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        padding: 0;
        margin: 5px 0;
    }
    .van-index-bar__index.curr{
        color: #07c160;
    }
    .index-bar{
        background-color: #fff;
        padding: 10px 20px;
        padding-right: 53px;
        padding-top: 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100%;
        overflow-y: auto;
    }
    .van-index-bar >>> .van-index-anchor{
        padding: 0;
    }
    .index-bg{
        color: #fff;
        display: flex;
        justify-content: space-between;
        height: 47px;
        background: #FFFFFF;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05);
        border-radius: 7px;
        padding-left: 20px;
        padding-right: 8px;
        align-items: center;
    }
    .index-name{
      font-size: 14px;
      line-height: 47px;
      height: 47px;
      color: #505050;
      letter-spacing: 2px;
      font-weight: 600;
    }
    .index-img{
      width: 62px;
      height: 45px;
    }
    .index-list{
        margin-top: 10px;
        margin-bottom: 5px;
    }
    .index-list-li{
        padding: 4px 12px;
        border: 1px solid #eee;
        border-radius: 5px;
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 5px;
        margin-top: 5px;
        max-width: 192px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 12px;
    }
</style>
